import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../services/auth.service';
import { TermsService } from '../services/terms.service';

@Injectable({
  providedIn: 'root',
})
export class TermsGuard  {

  public jwtHelperService = new JwtHelperService();
  readonly router = inject(Router);
  readonly auth$ = inject(AuthService);
  readonly termsService = inject(TermsService);

  private isInitialized = false;

  public canActivate() {
    const channel: { channelCode: any } = JSON.parse(
      localStorage.getItem('userChannelInfo')
    );

    const accessToken = localStorage.getItem('accessToken');
    const isTokenExpired = this.jwtHelperService.isTokenExpired(accessToken);

    if (!isTokenExpired && !this.isInitialized) {
      this.termsService
        .findMyTerms(channel?.channelCode || '0', accessToken)
        .subscribe({
          next: (response) => {
            this.isInitialized = true;
            
            setTimeout(() => {
              this.isInitialized = false;
            }, 5000);

            this.termsService.termsDataError$.next(false);
            let rememberLater = localStorage.getItem('isRememberLater')
              ? localStorage.getItem('isRememberLater')
              : false;
            const myTerms = response.terms;
            const termsNotAccepted = myTerms?.filter(
              (term) => term.termVersion.status !== 'ACCEPTED'
            );
            const requiredTerms = termsNotAccepted?.filter(
              (term) => term.termVersion.acceptanceRequired
            );

            if (
              termsNotAccepted?.length &&
              requiredTerms.length &&
              !rememberLater
            ) {
              this.router.navigate(['/terms']).then(() => {
                setTimeout(() => {
                  this.termsService.termsData$.next(termsNotAccepted);
                  this.termsService.termIsMandatoryAcceptance$.next(
                    response.isMandatoryAcceptance
                  );
                }, 1);
              });
              return false;
            } else {
              this.router.navigate(['/']);
              return true;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.termsService.termsData$.next([]);
            this.termsService.termsDataError$.next(true);
            this.router.navigate(['/terms']);
            return false;
          },
        });
    }

    return true;
  }

}
